export const GROUP_CATEGORIES = [
  {
    code: 'SOCIAL_FAMILY',
    label: 'group.category.socialFamily',
    desc: 'group.category.socialFamilyDesc',
    icon: 'heart',
  },
  {
    code: 'EDUCATION_ALUMNI',
    label: 'group.category.educationAlumni',
    desc: 'group.category.educationAlumniDesc',
    icon: 'school',
  },
  {
    code: 'RELIGIOUS_SPIRITUAL',
    label: 'group.category.religiousSpiritual',
    desc: 'group.category.religiousSpiritualDesc',
    icon: 'building-church',
  },
  {
    code: 'CULTURAL_IDENTITY',
    label: 'group.category.culturalIdentity',
    desc: 'group.category.culturalIdentityDesc',
    icon: 'world',
  },
  {
    code: 'WORK_BUSINESS',
    label: 'group.category.workBusiness',
    desc: 'group.category.workBusinessDesc',
    icon: 'briefcase',
  },
  {
    code: 'LEISURE_SPORT',
    label: 'group.category.leisureSport',
    desc: 'group.category.leisureSportDesc',
    icon: 'ball-football',
  },
  {
    code: 'ASSOCIATION_SOLIDARITY',
    label: 'group.category.associationSolidarity',
    desc: 'group.category.associationSolidarityDesc',
    icon: 'hand-heart',
  },
]

export const GROUP_TYPES_BY_CATEGORY = {
  SOCIAL_FAMILY: [
    { code: 'NUCLEAR_FAMILY', label: 'group.type.nuclearFamily' },
    { code: 'EXTENDED_FAMILY', label: 'group.type.extendedFamily' },
    { code: 'CLOSE_FRIENDS', label: 'group.type.closeFriends' },
    { code: 'NEIGHBOURS', label: 'group.type.neighbours' },
    { code: 'FLATMATES', label: 'group.type.flatmates' },
  ],
  EDUCATION_ALUMNI: [
    { code: 'CLASSMATES', label: 'group.type.classmates' },
    { code: 'ALUMNI_PROMOTION', label: 'group.type.alumniPromotion' },
    { code: 'ALUMNI_ASSOCIATION', label: 'group.type.alumniAssociation' },
    { code: 'STUDY_GROUP', label: 'group.type.studyGroup' },
    { code: 'PROFESSIONAL_TRAINING', label: 'group.type.professionalTraining' },
  ],
  RELIGIOUS_SPIRITUAL: [
    { code: 'CHURCH_PARISH', label: 'group.type.churchParish' },
    { code: 'MOSQUE_MUSLIM_COMMUNITY', label: 'group.type.mosqueMuslimCommunity' },
    { code: 'OTHER_FAITH', label: 'group.type.otherFaith' },
    { code: 'CHOIR_PRAISE', label: 'group.type.choirPraise' },
    { code: 'PRAYER_FELLOWSHIP', label: 'group.type.prayerFellowship' },
    { code: 'RELIGIOUS_YOUTH', label: 'group.type.religiousYouth' },
  ],
  CULTURAL_IDENTITY: [
    { code: 'ETHNIC_COMMUNITY', label: 'group.type.ethnicCommunity' },
    { code: 'REGIONAL_COMMUNITY', label: 'group.type.regionalCommunity' },
    { code: 'DIASPORA', label: 'group.type.diaspora' },
    { code: 'EXPATS', label: 'group.type.expats' },
    { code: 'CULTURAL_ASSOCIATION', label: 'group.type.culturalAssociation' },
  ],
  WORK_BUSINESS: [
    { code: 'COLLEAGUES', label: 'group.type.colleagues' },
    { code: 'TRADERS_INFORMAL', label: 'group.type.tradersInformal' },
    { code: 'PROFESSIONALS_FORMAL', label: 'group.type.professionalsFormal' },
    { code: 'FARMERS_COOPERATIVE', label: 'group.type.farmersCooperative' },
    { code: 'ENTREPRENEURS', label: 'group.type.entrepreneurs' },
    { code: 'UNION_PROFESSIONAL_ORDER', label: 'group.type.unionProfessionalOrder' },
    { code: 'ADVERTISERS_BRANDS', label: 'group.type.advertisersBrands' },
  ],
  LEISURE_SPORT: [
    { code: 'SPORTS_TEAM', label: 'group.type.sportsTeam' },
    { code: 'SPORTS_CLUB_FITNESS', label: 'group.type.sportsClubFitness' },
    { code: 'GAMING_ESPORT', label: 'group.type.gamingEsport' },
    { code: 'MUSIC_ARTS', label: 'group.type.musicArts' },
    { code: 'WELLNESS_HEALTH', label: 'group.type.wellnessHealth' },
    { code: 'READING_CULTURE', label: 'group.type.readingCulture' },
    { code: 'CREATIVE_CONTENT', label: 'group.type.creativeContent' },
  ],
  ASSOCIATION_SOLIDARITY: [
    { code: 'MUTUAL_AID_ASSOCIATION', label: 'group.type.mutualAidAssociation' },
    { code: 'HEALTH_SUPPORT_GROUP', label: 'group.type.healthSupportGroup' },
    { code: 'NGO_CIVIC', label: 'group.type.ngoCivic' },
    { code: 'CAUSE_ADVOCACY', label: 'group.type.causeAdvocacy' },
    { code: 'NEIGHBOURHOOD_COMMITTEE', label: 'group.type.neighbourhoodCommittee' },
    { code: 'TONTINE_MUTUAL', label: 'group.type.tontineMutual' },
  ],
}

export const ALL_GROUP_TYPES = Object.values(GROUP_TYPES_BY_CATEGORY).flat()

export function groupTypeLabel(code) {
  return ALL_GROUP_TYPES.find((t) => t.code === code)?.label ?? code
}

export function groupCategoryLabel(code) {
  return GROUP_CATEGORIES.find((c) => c.code === code)?.label ?? code
}

export const OWNERSHIP_TYPES = [
  { code: 'INDIVIDUAL', label: 'group.ownershipTypeIndividual', desc: 'group.ownershipTypeHint', icon: 'person_2' },
  { code: 'INFORMAL_ASSOCIATION', label: 'group.ownershipTypeInformal', desc: 'group.ownershipTypeHint', icon: 'person_2_fill' },
  { code: 'REGISTERED_ASSOCIATION', label: 'group.ownershipTypeRegistered', desc: 'group.ownershipTypeHint', icon: 'building_2' },
  { code: 'COMPANY', label: 'group.ownershipTypeCompany', desc: 'group.ownershipTypeHint', icon: 'briefcase' },
  { code: 'COOPERATIVE', label: 'group.ownershipTypeCooperative', desc: 'group.ownershipTypeHint', icon: 'square_grid_2x2' },
]

export const BENEFICIARY_TYPES = [
  { code: 'INDIVIDUAL', label: 'group.beneficiaryTypeIndividual', desc: 'group.beneficiaryTypeHint', icon: 'person' },
  { code: 'ORGANIZATION', label: 'group.beneficiaryTypeOrganization', desc: 'group.beneficiaryTypeHint', icon: 'building' },
]

export const GROUP_TAG_GROUPS = [
  {
    group: 'group.tagGroup.language',
    tags: [
      { code: 'LANGUAGE_FR', label: 'group.language.fr' },
      { code: 'LANGUAGE_DIOULA', label: 'group.language.dioula' },
      { code: 'LANGUAGE_BAOULE', label: 'group.language.baoule' },
      { code: 'LANGUAGE_BETE', label: 'group.language.bete' },
      { code: 'LANGUAGE_HAUSA', label: 'group.language.hausa' },
      { code: 'LANGUAGE_WOLOF', label: 'group.language.wolof' },
      { code: 'LANGUAGE_EN', label: 'group.language.en' },
    ],
  },
  {
    group: 'group.tagGroup.occasion',
    tags: [
      { code: 'OCCASION_WEDDING', label: 'group.occasion.wedding' },
      { code: 'OCCASION_BIRTHDAY', label: 'group.occasion.birthday' },
      { code: 'OCCASION_FUNERAL', label: 'group.occasion.funeral' },
      { code: 'OCCASION_BAPTISM', label: 'group.occasion.baptism' },
      { code: 'OCCASION_GRADUATION', label: 'group.occasion.graduation' },
      { code: 'OCCASION_RELIGIOUS_CELEBRATION', label: 'group.occasion.religiousCelebration' },
      { code: 'OCCASION_CULTURAL_FESTIVAL', label: 'group.occasion.culturalFestival' },
      { code: 'OCCASION_SPORTS_EVENT', label: 'group.occasion.sportsEvent' },
      { code: 'OCCASION_GALA_DINNER', label: 'group.occasion.galaDinner' },
      { code: 'OCCASION_RELIGIOUS_CELEBRATION', label: 'group.occasion.religiousCelebration' },
      { code: 'OCCASION_CULTURAL_FESTIVAL', label: 'group.occasion.culturalFestival' },
      { code: 'OCCASION_SPORTS_EVENT', label: 'group.occasion.sportsEvent' },
      { code: 'OCCASION_GALA_DINNER', label: 'group.occasion.galaDinner' },
      { code: 'OCCASION_HEALTH_EMERGENCY', label: 'group.occasion.healthEmergency' },
      { code: 'OCCASION_SCHOOL_FEES', label: 'group.occasion.schoolFees' },
    ],
  },
  {
    group: 'group.tagGroup.sector',
    tags: [
      { code: 'SECTOR_AGRICULTURE', label: 'group.sector.agriculture' },
      { code: 'SECTOR_TRADE_RETAIL', label: 'group.sector.tradeRetail' },
      { code: 'SECTOR_CONSTRUCTION', label: 'group.sector.construction' },
      { code: 'SECTOR_TRANSPORT', label: 'group.sector.transport' },
      { code: 'SECTOR_HEALTH_PHARMA', label: 'group.sector.healthPharma' },
      { code: 'SECTOR_EDUCATION', label: 'group.sector.education' },
      { code: 'SECTOR_TECHNOLOGY', label: 'group.sector.technology' },
      { code: 'SECTOR_FINANCE_BANKING', label: 'group.sector.financeBanking' },
      { code: 'SECTOR_MEDIA_CREATIVE', label: 'group.sector.mediaCreative' },
      { code: 'SECTOR_FOOD_BEVERAGE', label: 'group.sector.foodBeverage' },
      { code: 'SECTOR_TEXTILE_FASHION', label: 'group.sector.textileFashion' },
      { code: 'SECTOR_NGO_NONPROFIT', label: 'group.sector.ngoNonprofit' },
    ],
  },
]